import { axios } from "utils";

import { ADMIN_CROP_EXPLORER_URL as endpoint } from "consts";

import {
  CropExplorationCreationResponse,
  CropExplorationEntryCreationResponse,
  CropExplorationEntryRequest,
  CropExplorationTemplateRequest,
  CropExplorationTemplateResponse,
} from "models";

export const addCropExplorationTemplate = async (cropExploration: CropExplorationTemplateRequest): Promise<CropExplorationCreationResponse> =>
  axios.post(`${endpoint}/`, { data: cropExploration });

export const updateCropExplorationTemplate = async ({ id, cropExploration }: { id: string; cropExploration: CropExplorationTemplateRequest }) =>
  axios.put(`${endpoint}/${id}`, { data: cropExploration });

export const getCropExplorationTemplates = async (signal: AbortSignal): Promise<CropExplorationTemplateResponse[] | []> =>
  axios.get(`${endpoint}/`, { signal: signal });

export const deleteCropExplorationTemplate = async ({ id }: { id: string }) => axios.delete(`${endpoint}/${id}`);

export const deleteCropExplorationTemplateYear = async ({ id, year }: { id: string; year: string }) => axios.delete(`${endpoint}/${id}/year/${year}`);

export const duplicateCropExplorationTemplateEntry = async ({
  id,
  sourceYear,
  targetYear,
}: {
  id: string;
  sourceYear: number;
  targetYear: number;
}): Promise<{ ids: string[] }> => axios.post(`${endpoint}/${id}/years/${sourceYear}/duplicates`, { targetYear });

// Entries

export const addCropExplorationTemplateEntry = async ({
  cropExplorationId,
  crop,
}: {
  cropExplorationId: string;
  crop: CropExplorationEntryRequest;
}): Promise<CropExplorationEntryCreationResponse> => axios.post(`${endpoint}/${cropExplorationId}/entries`, { data: crop });

export const updateCropExplorationTemplateEntry = async ({
  cropExplorationId,
  entryId,
  crop,
}: {
  cropExplorationId: string;
  entryId: string;
  crop: CropExplorationEntryRequest;
}) => axios.put(`${endpoint}/${cropExplorationId}/entries/${entryId}`, { data: crop });

export const deleteCropExplorationTemplateEntry = async ({ id }: { id: string }) => axios.delete(`${endpoint}/entries/${id}`);
